import { AppRoute } from "../../../core/routing/AppRoute";

import { AuthGuard } from "../../common/rest-api/services/auth-guard.service";
import { MainAdminPage } from "./pages/main-admin/main-admin.page";
import { WoApprovalPage } from "./pages/wo-approval/wo-approval.page";
import { CostCenterAdminPage } from "./pages/cost-center-admin/cost-center-admin.page";
import { WebSiteSettingAdminPage } from "./pages/web-site-setting-admin/web-site-setting-admin.page";
import { HandheldSettingAdminPage } from "./pages/handheld-setting-admin/handheld-setting-admin.page";
import { ImageUploadPage } from "./pages/image-upload/image-upload.page";
import { WebProductAdminPage } from "./pages/web-product-admin/web-product-admin.page";
import { WebEmblemsAdminPage } from "./pages/web-emblems-admin/web-emblems-admin.page";
import { WebCustomerProductPage } from "./pages/web-customer-product/web-customer-product.page";
import { WebOrderTypeAdminPage } from "./pages/web-order-type-admin/web-order-type-admin.page";
import { WebOrderTypeStepsPage } from "./pages/web-order-type-steps/web-order-type-steps.page";
import { CustomerSiteReportPage } from "./pages/customer-site-reports/customer-site-reports.page";
import { WebCustomerProductEditPage } from "./pages/web-customer-product-edit/web-customer-product-edit.page";
import { WebProductEditPage } from "./pages/web-product-edit/web-product-edit.page";
import { RouteCommentAdminPage } from "./pages/route-comment-admin/route-comment-admin.page";
import { GarmentReturnReviewPage } from "./pages/garment-return-review-page/garment-return-review.page";
import { CostCenterEmployeeViewPage } from "./pages/cost-center-employee-view/cost-center-employee-view.page";
import { CustomerCancelOrderPage } from './pages/customer-cancel-order/customer-cancel-order.page';
import { GarmentReturnCustomerReviewPage } from './pages/garment-return-customer-review/garment-return-customer-review.page';
import { GarmentReturnDepartmentReviewPage } from './pages/garment-return-department-review/garment-return-deprtment-review.page';
import { GarmentReturnEmployeeReviewPage } from './pages/garment-return-employee-review/garment-return-employee-review.page';
import { WebOrderViewModalComponent } from './pages/web-order-view/web-order-view.page';
import { CustomerSiteAdminPage } from './pages/custom-site-admin/custom-site-admin.page';
import { CustomSiteAdminEditPage } from './pages/custom-site-admin-edit/custom-site-admin-edit.page';
import { QueryViewPage } from './pages/query-view/query-view.page';
// A feature route should be used in the App routing module in most cases and primarily provide
// a base url and module loading functionality.
// The feature route should employ a load children callback that loads the appropriate module
const Feature = new AppRoute({
  segment: "admin-page",
  title: "Admin Page",
  // A component can also be included to be the content, or a separate route with a blank segment
  // can be defined like below to provide a dedicated route instance
  // component: GarmentListingPage,
  loadChildren: () =>
    import("./admin-page.module").then((m) => m.AdminPageModule),
  canActive: [AuthGuard],
});

// "Sub-routes" should be the contentful endpoints for the feature. To provide content at the base
// level of the feature url, simply leave segment blank.
// Provide the parent parameter to be able to derive the fullPath of a route that includes the base
const Main = new AppRoute({
  segment: '',
  title: 'Admin Page',
  component: MainAdminPage,
  parent: Feature,
  canActive: [AuthGuard]
});


const CostCenter = new AppRoute({
  segment: "cost-center",
  title: "Cost Center Admin",
  component: CostCenterAdminPage,
  parent: Main,
  canActive: [AuthGuard],
});
const SettingWebSite= new AppRoute({
  segment: "setting-admin",
  title: "Setting Admin",
  component: WebSiteSettingAdminPage,
  parent: Main,
  canActive: [AuthGuard],
});
const SettingHandheld = new AppRoute({
  segment: "handheld-setting-admin",
  title: "Setting Admin",
  component: HandheldSettingAdminPage,
  parent: Main,
  canActive: [AuthGuard],
});
const ImageUpload = new AppRoute({
  segment: "image-upload",
  title: "Image Upload",
  component: ImageUploadPage,
  parent: Main,
  canActive: [AuthGuard],
});

const RouteCommentAdmin = new AppRoute({
  segment: "route-comment-admin",
  title: "Route Comment Setting Admin",
  component: RouteCommentAdminPage,
  parent: Main,
  canActive: [AuthGuard],
});
const WebProductAdmin = new AppRoute({
  segment: "web-product-admin",
  title: "Web Product admin",
  component: WebProductAdminPage,
  parent: Main,
  canActive: [AuthGuard],
});
const WebEmblemsAdmin = new AppRoute({
  segment: "web-emblems-admin",
  title: "Web Emblems admin",
  component: WebEmblemsAdminPage,
  parent: Main,
  canActive: [AuthGuard],
});
const WebCustomerProduct = new AppRoute({
  segment: "web-customer-product",
  title: "Web Customer Product",
  component: WebCustomerProductPage,
  parent: Main,
  canActive: [AuthGuard],
});
const WebCustomerProductEdit = new AppRoute({
  segment: "web-customer-product/edit/:cid/:pid",
  title: "Web Customer Product edit",
  component: WebCustomerProductEditPage,
  parent: Main,
  canActive: [AuthGuard],
});
const WebOrderTypeAdmin = new AppRoute({
  segment: "web-order-type-admin",
  title: "Web Order Type Admin",
  component: WebOrderTypeAdminPage,
  parent: Main,
  canActive: [AuthGuard],
});
const WebOrderTypeSteps = new AppRoute({
  segment: "web-order-type-admin/steps/:id",
  title: "Web Order Type Admin",
  component: WebOrderTypeStepsPage,
  parent: Main,
  canActive: [AuthGuard],
});
const CustomerSiteReport = new AppRoute({
  segment: "customer-site-reports",
  title: "customer site reports",
  component: CustomerSiteReportPage,
  parent: Main,
  canActive: [AuthGuard],
});
const CustomSiteAdmin = new AppRoute({
  segment: "custom-site-admin",
  title: "custom site admin",
  component: CustomerSiteAdminPage,
  parent: Main,
  canActive: [AuthGuard],
});
const CustomSiteAdminEdit = new AppRoute({
  segment: "custom-site-admin/edit/:id",
  title: "custom site admin",
  component: CustomSiteAdminEditPage,
  parent: Main,
  canActive: [AuthGuard],
});
const CustomSiteAdminAdd = new AppRoute({
  segment: "custom-site-admin/add",
  title: "custom site admin",
  component: CustomSiteAdminEditPage,
  parent: Main,
  canActive: [AuthGuard],
});
const WebProductEdit = new AppRoute({
  segment: "web-product-admin/edit/:id/:type/:action",
  title: "Web Product edit",
  component: WebProductEditPage,
  parent: Main,
  canActive: [AuthGuard],
});
const WebEmblemEdit = new AppRoute({
  segment: "web-emblems-admin/edit/:id/:type/:action",
  title: "Web Product edit",
  component: WebProductEditPage,
  parent: Main,
  canActive: [AuthGuard],
});


const CostCenterEmployeeView = new AppRoute({
  segment: "cost-center/:costCenterCode",
  title: "Cost Center Employee View",
  component: CostCenterEmployeeViewPage,
  parent: Main,
  canActive: [AuthGuard],
});

const WoApproval = new AppRoute({
  segment: "wo-approval",
  title: "Work Order Approval",
  component: WoApprovalPage,
  parent: Main,
  canActive: [AuthGuard],
});
const ViewWebOrder = new AppRoute({
  segment: "wo-approval/view-web-order",
  title: "Work Order View",
  component: WebOrderViewModalComponent,
  parent: Main,
  canActive: [AuthGuard],
});
const customerReport = new AppRoute({
  segment: "customer-site-reports/cancel-report",
  title: "customer Cancel report",
  component: CustomerCancelOrderPage,
  parent: Main,
  canActive: [AuthGuard],
});
const garmentReturnReview = new AppRoute({
  segment: "customer-site-reports/garment-return-review",
  title: "garment return review",
  component: GarmentReturnReviewPage,
  parent: Main,
  canActive: [AuthGuard],
});
const queryView = new AppRoute({
  segment: "customer-site-reports/query-view/:id",
  title: "query view",
  component: QueryViewPage,
  parent: Main,
  canActive: [AuthGuard],
});
const garmentReturnCustomerReview = new AppRoute({
  segment: "customer-site-reports/garment-return-review/customer/:id",
  title: "garment return review",
  component: GarmentReturnCustomerReviewPage,
  parent: Main,
  canActive: [AuthGuard],
});
const garmentReturnEmployeeReview = new AppRoute({
  segment: "customer-site-reports/garment-return-review/employee/:cid/:did/:id",
  title: "garment return review",
  component: GarmentReturnEmployeeReviewPage,
  parent: Main,
  canActive: [AuthGuard],
});
const garmentReturnDepartmentReview = new AppRoute({
  segment: "customer-site-reports/garment-return-review/department/:cid/:id",
  title: "garment return review",
  component: GarmentReturnDepartmentReviewPage,
  parent: Main,
  canActive: [AuthGuard],
});


export const AdminRoutes = {
  Feature: Feature,
  Main: Main,
  CostCenter: CostCenter,
  WoApproval: WoApproval,
  CostCenterEmployeeView: CostCenterEmployeeView,
  SettingWebSite:SettingWebSite,
  SettingHandheld:SettingHandheld,
  RouteCommentAdmin:RouteCommentAdmin,
  ImageUpload:ImageUpload,
  WebProductAdmin:WebProductAdmin,
  WebProductEdit:WebProductEdit,
  WebEmblemsAdmin:WebEmblemsAdmin,
  WebEmblemEdit:WebEmblemEdit,
  WebCustomerProduct:WebCustomerProduct,
  WebCustomerProductEdit:WebCustomerProductEdit,
  WebOrderTypeAdmin:WebOrderTypeAdmin,
  WebOrderTypeSteps:WebOrderTypeSteps,
  CustomerSiteReport:CustomerSiteReport,
  customerReport:customerReport,
  garmentReturnReview:garmentReturnReview,
  garmentReturnCustomerReview:garmentReturnCustomerReview,
  garmentReturnDepartmentReview:garmentReturnDepartmentReview,
  garmentReturnEmployeeReview:garmentReturnEmployeeReview,
  ViewWebOrder:ViewWebOrder,
  queryView:queryView,
  CustomSiteAdmin:CustomSiteAdmin,
  CustomSiteAdminEdit:CustomSiteAdminEdit,
  CustomSiteAdminAdd:CustomSiteAdminAdd
};
